module.exports = "/_next/static/images/7426ccafee112b9d3a79a062d9431f4c-credit-card-limit@2x.png.webp";